import React, { useState } from "react";
import EnquiryImg from "../images/enquiry/enquiry.png";
import { serverUrl } from "../utils/Constants";
import axios from "axios";
import "../styles/enquiry.css";

export default function Enquiry() {
  // const [formState, setFormState] = useState({});
  const [popupMessage, setPopupMessage] = useState(null);

  // function changeHandler(event) {
  //   setFormState({ ...formState, [event.target.name]: event.target.value });
  // }

  function submitHandler(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append("formType", "enquiry");

    try {
      axios.post(`${serverUrl}/send-email.php`, formData).then((res) => {
        e.target.reset();
        setPopupMessage("Message successfully sent!");
      });
    } catch (error) {
      setPopupMessage("An error occurred. Please try again.");
    }
  }

  return (
    <>
      <section id="enquiry">
        <div className="mcare-enquiry">
          <div className="container">
            <h2 align="left" style={{ fontSize: "30px" }} className="add-border-bottom">
              Enquiry & <span style={{ color: "#005598" }}>Feedback</span>
            </h2>
            <div className="row g-3">
              <div className="col-lg-7 col-md-12">
                <form onSubmit={submitHandler}>
                  <div className="row mb-3">
                    <label htmlFor="inputName" className="col-sm-4 col-form-label move-text ">
                      <strong>Name:</strong>
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control" name="name" id="inputName" />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label htmlFor="inputOrganization" className="col-sm-4 col-form-label move-text">
                      <strong>Organization:</strong>
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control" name="organization" id="inputOrganization" />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label htmlFor="inputAddress" className="col-sm-4 col-form-label move-text">
                      <strong>Address:</strong>
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control" name="address" id="inputAddress" />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label htmlFor="inputPhone" className="col-sm-4 col-form-label move-text">
                      <strong>Tel No.:</strong>
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control" name="telephone" id="inputPhone" />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label htmlFor="inputEmail" className="col-sm-4 col-form-label move-text">
                      <strong>Email:</strong>
                    </label>
                    <div className="col-sm-8">
                      <input type="email" className="form-control" name="email" id="inputEmail" />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label htmlFor="inputRequirements" className="col-sm-4 col-form-label move-text">
                      <strong>Describe your requirements:</strong>
                    </label>
                    <div className="col-sm-8">
                      <textarea className="form-control" name="requirements" id="inputRequirements" rows="3"></textarea>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label htmlFor="inputCity" className="col-sm-4 col-form-label move-text">
                      <strong>City:</strong>
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control" name="city" id="inputCity" />
                    </div>
                  </div>
                  <div className="row mb-3" style={{ textAlign: "left" }}>
                    <label htmlFor="" className="col-sm-4 col-form-label"></label>
                    <div className="col-sm-8">
                      <button type="submit" className="btn btn-primary" style={{ color: "black", backgroundColor: "white", borderColor: "#ccc" }}>
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
                {popupMessage && (
                  <div className="popup">
                    <p>{popupMessage}</p>
                    <button onClick={() => setPopupMessage(null)}>Close</button>
                  </div>
                )}
              </div>
              <div className="col-lg-5 col-md-12">
                <img src={EnquiryImg} alt="..." />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
